import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import Input from "Components/Input/Input";
import { read } from "Helpers/LocalStorage";
import {
  getAllGoroupUserData,
  insertGoroupUserPriceData,
} from "Stores/actions";
import { Grid } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import { toggleNPercentRiyal } from "Constants/Constants";
import * as R from "ramda";
import { useTranslation } from "react-i18next";
import MuiButton from "Components/MuiButton/MuiButton";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

export default function NewUsersGroup() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    profile: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentProfile",
    },
    isPercentProfile: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "profile",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    fitting: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentFitting",
    },
    isPercentFitting: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "fitting",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    glass: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentGlass",
    },
    isPercentGlass: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "glass",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    net: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentNet",
    },
    isPercentNet: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "net",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    other: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentOther",
    },
    isPercentOther: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "other",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    service: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercentService",
    },
    isPercentService: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: "service",
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
  });

  const dispatch = useDispatch();

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ [controls[name].relation]: { value: 0 } });
  };

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setCheckValid(false);
    setFormValid({});
    setControls({ name: { value: "" } });
    setControls({ profile: { value: 0 } });
    setControls({ fitting: { value: 0 } });
    setControls({ glass: { value: 0 } });
    setControls({ net: { value: 0 } });
    setControls({ other: { value: 0 } });
    setControls({ service: { value: 0 } });
    setControls({ isPercentProfile: { value: toggleNPercentRiyal[0] } });
    setControls({ isPercentFitting: { value: toggleNPercentRiyal[0] } });
    setControls({ isPercentGlass: { value: toggleNPercentRiyal[0] } });
    setControls({ isPercentNet: { value: toggleNPercentRiyal[0] } });
    setControls({ isPercentOther: { value: toggleNPercentRiyal[0] } });
    setControls({ isPercentService: { value: toggleNPercentRiyal[0] } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const {
      name,
      profile,
      fitting,
      glass,
      net,
      other,
      service,
      isPercentProfile,
      isPercentFitting,
      isPercentGlass,
      isPercentNet,
      isPercentOther,
      isPercentService,
    } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IsPercentNet: isPercentNet.value.value,
          IsPercentOther: isPercentOther.value.value,
          Fitting: convertToEnglishNumber(fitting.value),
          IsPercentService: isPercentService.value.value,
          Glass: convertToEnglishNumber(glass.value),
          Service: convertToEnglishNumber(service.value),
          IsPercentProfile: isPercentProfile.value.value,
          Profile: convertToEnglishNumber(profile.value),
          Name: name.value,
          IsPercentGlass: isPercentGlass.value.value,
          IsPercentFittin: isPercentFitting.value.value,
          Net: convertToEnglishNumber(net.value),
          Other: convertToEnglishNumber(other.value),
        };
        await dispatch(insertGoroupUserPriceData(data));
        onClear();
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllGoroupUserData(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <Grid container spacing={2} className="new-customer-group-section">
      <span className="normalTitle">{t("newUserGroup")}</span>
      <Grid item xs={12} className="px-0">
        <Input
          setValue={setValue.bind(this)}
          name="name"
          value={controls.name.value}
          validation={controls.name.validation}
          label={<Translator id="name_groh_jadid" />}
          type="text"
          checkValid={checkValid}
        />
      </Grid>
      <Grid item xs={12}>
        {Object.keys(controls)
          .filter((key) => controls[key].box === 1)
          .map((key, index) => {
            return (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls[key].value}
                    name={key}
                    placeholder={t(key)}
                    validation={controls[key].validation}
                    label={<Translator id={key} />}
                    type={controls[key].type}
                    checkValid={checkValid}
                    endIcon={
                      controls[controls[key].relation].value.value ? (
                        "%"
                      ) : (
                        <Translator id={"moneyUnit"} />
                      )
                    }
                    radioGroup={{
                      name: controls[key].relation,
                      value: controls[controls[key].relation].value,
                      items: controls[controls[key].relation].arrayItems,
                      onChange: onChangeToggle,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
      </Grid>
      <Grid item xs={12} className="px-0">
        <MuiButton
          loading={loading}
          color="primary"
          title={<Translator id="ezafe_be_list" />}
          onClick={onFinish}
          disabled={!formValid.name}
          className="w-100 mt-4"
        />
      </Grid>
    </Grid>
  );
}
